<template>
  <!-- 정산/발행 >> Non-Freight Invoice -->
  <div>
    <div class="content_box beforetab">
      <!-- content_box  -->
      <div id="container_return_pdf_pop">
        <win-layer-pop class="pdf_download_pop">
          <component
            v-if="pdfCustomComponent"
            :is="pdfCustomComponent"
            @close="closePdfPopup"
            :parent-info="pdfPopupParams"
          />
        </win-layer-pop>
      </div>
      <table class="tbl_search">
        <colgroup>
          <col width="150px"><col width="259px"><col width="*"><col width="100px">
        </colgroup>
        <tbody>
          <tr>
            <td class="pr5">
              <select v-model="params.dtKnd">
                <option value="BL">B/L No. <!--  B/L No. --> </option>
                <option value="IV">{{ $t('msg.SETT010T010.096') }}</option> <!-- Invoice No -->
                <option value="ID">Issue Date</option>
              </select>
            </td>
            <td colspan="2" class="pl0">
              <div v-if="params.dtKnd === 'BL'">
                <input type="text" style="width:200px" v-model.trim="params.blNo" @keyup.enter="searchData" @input="params.blNo=params.blNo.toUpperCase()">
              </div>
              <div v-if="params.dtKnd === 'IV'">
                <input type="text" style="width:200px" v-model.trim="params.invNo" @keyup.enter="searchData()" @input="params.invNo=params.invNo.toUpperCase()">
              </div>
              <div v-if="params.dtKnd === 'ID'">
                <e-date-range-picker
                  :id="'fromDtToDt'"
                  :term-type="termType"
                  :show-term-type="['01', '02', '03', '04']"
                  :sdate="range.sdate"
                  :edate="range.edate"
                  @change="changeDateRange"
                />
              </div>
            </td>
            <td class="text_right">
              <a class="button blue sh" @click="searchData()">{{ $t('msg.CMBA100.00120') }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div><!-- cpntent_box // -->

    <div class="content_box mt10">
      <!-- content_box  -->
      <div class="flex_box">
        <span class="tot_num">Total : <span class="num">{{ total }}</span></span>
      </div>
      <div id="nonfreight-realgrid" style="width: 100%; height: 450px"></div>
    </div><!-- content_box// -->
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil'
import JSZip from 'jszip'
import moment from 'moment'
import CalcIssue from '@/api/rest/settle/calcIssue'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import { rootComputed } from '@/store/helpers'
import _lodash from 'lodash'
import store from '@/store/index'
import commons from '@/api/services/commons'
import doapi from '@/api/rest/trans/do'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'invIssNo', dataType: 'text' },
  { fieldName: 'invKndCd', type: 'hidden' },
  { fieldName: 'invKndNm', dataType: 'text' },
  { fieldName: 'issDt', dataType: 'text' },
  { fieldName: 'ctrCd', dataType: 'text' },
  { fieldName: 'plcCd', dataType: 'text' },
  { fieldName: 'blNo', dataType: 'text' },
  { fieldName: 'cstNo', dataType: 'text' },
  { fieldName: 'curCd', dataType: 'text' },
  { fieldName: 'locAmt', dataType: 'number' },
  { fieldName: 'dcAmt', dataType: 'number' },
  { fieldName: 'exrt', dataType: 'number' },
  { fieldName: 'usdAmt', dataType: 'number' },
  { fieldName: 'cnclYn', dataType: 'text' },
  { fieldName: 'cnclDt', dataType: 'text' },
  { fieldName: 'cnclUno', dataType: 'text' },
  { fieldName: 'rcvCpltYn', dataType: 'text' },
  { fieldName: 'rcvDt', dataType: 'text' },
  { fieldName: 'acshRno', dataType: 'text' },
  { fieldName: 'eiCatCd', dataType: 'text' },
  { fieldName: 'invoiceBtn', dataType: 'text' },
  { fieldName: 'agtOrgNo', type: 'hidden' }
]

export const columns = [
  { name: 'invIssNo', fieldName: 'invIssNo', type: 'text', header: { text: 'Invoice No.' }, editable: false, width: 80 },
  {
    name: 'invoiceBtn',
    fieldName: 'invoiceBtn',
    type: 'text',
    header: { text: 'Invoice' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const invIssNo = provider.getValue(idx, 'invIssNo') === null ? '' : provider.getValue(idx, 'invIssNo')
        const strInvIssNo = _lodash.trim(invIssNo || '')

        let str = '-'
        if (strInvIssNo === '') {
          str = ''
        } else {
          str = `<span class="tbl_icon invoice" style="cursor:pointer;" title="${strInvIssNo}"></span>`
        }
        return str
      }
    },
    width: 40
  },
  // { name: 'invKndNm', fieldName: 'invKndNm', type: 'text', header: { text: 'Kind' }, editable: false, width: 100 },
  {
 name: 'issDt',
    fieldName: 'issDt',
    type: 'text',
    header: { text: 'Issue Date' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const data = cell.value ? cell.value : ''

        var y = data.substring(0, 4)
        var m = data.substring(4, 6)
        var d = data.substring(6, 8)

        return y + '.' + m + '.' + d
      }
    },
    width: 80
  },
  { name: 'ctrCd', fieldName: 'ctrCd', type: 'text', header: { text: 'CN' }, editable: false, width: 40 },
  { name: 'plcCd', fieldName: 'plcCd', type: 'text', header: { text: 'Place' }, editable: false, width: 40 },
  { name: 'blNo', fieldName: 'blNo', type: 'text', header: { text: 'BL No.' }, editable: false, width: 70 },
  { name: 'cstNo', fieldName: 'cstNo', type: 'text', header: { text: 'Customer' }, editable: false, width: 120 },
  { name: 'curCd', fieldName: 'curCd', type: 'text', header: { text: 'CUR' }, editable: false, width: 40 },
  { name: 'locAmt', fieldName: 'locAmt', type: 'number', numberFormat: '#,##0.00', header: { text: 'Local Amount' }, editable: false, width: 80 },
  { name: 'dcAmt', fieldName: 'dcAmt', type: 'number', numberFormat: '#,##0.00', header: { text: 'D/C Amt' }, editable: false, width: 60 },
  { name: 'exrt', fieldName: 'exrt', type: 'number', numberFormat: '#,##0.00', header: { text: 'Exch Rate' }, editable: false, width: 60 },
  { name: 'usdAmt', fieldName: 'usdAmt', type: 'number', numberFormat: '#,##0.00', header: { text: 'USD Amt' }, editable: false, width: 60 }
  // { name: 'cnclYn', fieldName: 'cnclYn', type: 'text', header: { text: 'Cancel' }, editable: false },
  // { name: 'cnclDt', fieldName: 'cnclDt', type: 'text', header: { text: 'Cancel Date' }, editable: false },
  // { name: 'cnclUno', fieldName: 'cnclUno', type: 'text', header: { text: 'Cancel User' }, editable: false, width: 80 },
  // { name: 'rcvCpltYn', fieldName: 'rcvCpltYn', type: 'text', header: { text: 'Pay Complete' }, editable: false, width: 80 },
  // { name: 'rcvDt', fieldName: 'rcvDt', type: 'text', header: { text: 'Pay Date' }, editable: false },
  // { name: 'acshRno', fieldName: 'acshRno', type: 'text', header: { text: 'Receipt No.' }, editable: false, width: 140 },
  // { name: 'eiCatCd', fieldName: 'eiCatCd', type: 'text', header: { text: 'InOut' }, editable: false }
]

export default {
  name: 'CalcIssueNonFreight',
  components: {
    CalcIssue,
    EBreadcrumbs,
    'win-layer-pop': () => import('@/pages/trans/popup/WinLayerPop'),
    'container-return-pop': () => import('@/pages/pdf/popup/ContainerReturnPop'),
    'e-date-range-picker': () => import('@/components/common/EDateRangePicker')
  },
  props: {
    paramData: {
      type: Object,
      default () {
        return {
          tab: '',
          keyword: '',
          dtKnd: '',
          eiCateCd: ''
        }
      }
    }
  },
  data: function () {
    return {
      // PDF 다운로드 팝업 컴포넌트
      pdfCustomComponent: null,
      pdfPopupParams: {},
      total: 0,
      dtType: {
        options: [
          { value: 'IV', text: this.$t('msg.SETT010T010.096') }
        ]
      },
      content: {
        invIssNo: '',
        cstEnm: '',
        eicatCd: '',
        demDetCatCd: '',
        totAmt: '',
        blNo: '',
        agtOrgNo: ''
      },
      params: {
        dtKnd: 'ID'
      },
      termType: '02',
      range: {
        sdate: '',
        edate: ''
      },
      rstList: [],
      rstFilter: []
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {

  },
  created () {
    console.log('App', app.$t('tit.SETTLE.TAB01.GRID_HEADER.001'))
    window.functionOutsideVue(this)
    this.userDmdCatCd = this.$store.state.settle.userDmdCatCd
    window.vmApp = this
  },
  mounted: function () {
    this.setDateRange()
    //
    window.vmApp = this
    window.settleAppTab7 = this
    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    const grid = createGrid('nonfreight-realgrid', {
      fields,
      columns,
      header: { heights: [40] },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'evenFill',
        selectionStyle: 'block'
      },
      footer: { visible: false },
      stateBar: { visible: false },
      rowIndicator: { visible: false },
      checkBar: { visible: false }
    })
    gridView = grid.gridView
    provider = grid.provider

    // [중요] 여기에 클릭 이벤트를 추가하세요!
    gridView.onCellClicked = (grid, clickData) => {
        // 1. 클릭한 컬럼이 'invoiceBtn'인지 확인
        if (clickData.column === 'invoiceBtn') {
            const currentIdx = clickData.dataRow

            // 2. 유효한 행인지 확인 후 팝업 오픈 함수 호출
            // 화살표 함수(=>)를 썼기 때문에 여기서 'this'는 Vue 컴포넌트입니다.
            if (currentIdx > -1) {
                // 값이 있을때만 열고 싶다면 아래 조건 추가
                const invIssNo = provider.getValue(currentIdx, 'invIssNo')
                if (invIssNo) {
                    this.openPdfPopup(currentIdx)
                }
            }
        }
    }
   },
  methods: {
    openPdfPopup (idx) {
      if (this.pdfCustomComponent !== null) {
        this.pdfCustomComponent = null
        this.$ekmtcCommon.layerClose()
      }

      const pdfData = this.rstList[idx]

      pdfData.title = 'Non-Freight Invoice'
      console.log('openPdfPopup @@@@ ', pdfData)

      this.pdfCustomComponent = 'container-return-pop'
      this.pdfPopupParams = pdfData

      this.$ekmtcCommon.layerOpen('#container_return_pdf_pop > .popup_dim')
    },
    // PDF 다운로드 팝업 닫기
    closePdfPopup () {
      this.pdfCustomComponent = null
      this.$ekmtcCommon.layerClose('#container_return_pdf_pop > .popup_dim')
    },
    openAlert (msg) {
      let obj = {
        alertType: 'simple',
        onClose: this.closeFun,
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('msg.CSBK100.137'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    },
    async searchData () {
      let param = {
        invNo: this.params.invNo
      }

      this.rstList = []
      this.rstFilter = []

      console.log(JSON.stringify(this.params))

      // if (this.optionChk()) {
        await CalcIssue.selectNonFreightInvoice(this.params).then(response => {
          console.log('response @@@@ ', response)

          if (response.data !== '') {
            const resp = response.data
            this.rstList = resp
            this.rstFilter = resp
            this.total = this.rstList.length
            provider.setRows(this.rstList)
          } else {
            this.total = 0
            provider.setRows(this.rstList)
            this.openAlert(this.$t('msg.SETT010T010.129'))
          }
        }).catch(err => {
            console.log(err)
        })
      // }
    },
    changeDateRange (s, d) {
      this.params.fromDt = s
      this.params.toDt = d

      this.checkFrom = moment(s).format('YYYY-MM-DD')
      this.checkTo = moment(d).format('YYYY-MM-DD')

      this.checkSearchValidation('fromDtToDt')
    },
    setDateRange () {
      this.range = {
        sdate: this.getWeekDt(-7),
        edate: this.getWeekDt(7)
      }
      this.params.fromDt = this.range.sdate
      this.params.toDt = this.range.edate
    },
    getWeekDt (n) {
      let d = new Date()
      let dayOfMonth = d.getDate()
      d.setDate(dayOfMonth + n)
      return this.getDateStr(d)
    },
    getDateStr (myDate) {
      let year = myDate.getFullYear()
      let month = (myDate.getMonth() + 1)
      let day = myDate.getDate()

      month = (month < 10) ? '0' + String(month) : month
      day = (day < 10) ? '0' + String(day) : day

      return year.toString() + month.toString() + day.toString()
    },
    checkSearchValidation (id) {
      const searchParams = this.params
      const frm = document.querySelector('#frm')
      let selector = document.querySelector('#' + id)
      let isOk = true

      if (selector === null || selector === undefined) {
        return true
      }

      this.$ekmtcCommon.hideErrorTooltip(selector)
      // this.localHideErrorTooltip(selector)

      switch (id) {
        case 'fromDtToDt':
          var fromDt = new Date(this.checkFrom)
          var toDt = new Date(this.checkTo)

          if (this.params.dtKnd !== 'BL' && (this.$ekmtcCommon.isEmpty(this.params.fromDt) || this.$ekmtcCommon.isEmpty(this.params.toDt))) {
            this.LocalShowErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          } else if (this.params.dtKnd !== 'BL' && fromDt > toDt) {
            this.LocalShowErrorTooltip(selector, this.$t('msg.ONEX010T010.128'))
            isOk = false
          }
          break
      }
      return isOk
    },
    optionChk () {
      if (this.params.dtKnd === 'Bk') {
        if (this.params.blNo === '') {
            this.openAlert(this.$t('msg.CSCT060G060.025')) // B/L NO를 입력하여 주세요.
            return false
        }
      } else {
        if (this.params.fromDt === '') {
            this.openAlert('Please input start date.')
            return false
        }
        if (this.params.toDt === '') {
            this.openAlert('Please input end date.')
            return false
        }
        if (this.params.invNo === '' || this.params.invNo === undefined) {
          this.openAlert('Invoice 번호를 입력하세요.')
          return false
        }
      }
      return true
    }
  }
}

</script>
